import { reactive, toRefs } from 'vue'
import axios from 'axios'

export default function useMachineTypes() {
  const machine_types_state = reactive({
    machine_types: [],
  })

  const listMachineTypes = async () => {
    await axios
      .get('/api/machine_types/all')
      .then(function (response) {
        machine_types_state.machine_types = response.data.data
      })
      .catch(function () {
        //
      })
  }

  return { ...toRefs(machine_types_state), listMachineTypes }
}
